import { render, staticRenderFns } from "./QuickInvoiceSideMenu.vue?vue&type=template&id=9965260a"
import script from "./QuickInvoiceSideMenu.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9965260a')) {
      api.createRecord('9965260a', component.options)
    } else {
      api.reload('9965260a', component.options)
    }
    module.hot.accept("./QuickInvoiceSideMenu.vue?vue&type=template&id=9965260a", function () {
      api.rerender('9965260a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickinvoice/QuickInvoiceSideMenu.vue"
export default component.exports